export const enReportServiceType: Record<number, string> = {
  1: "Longevity treatments",
  2: "IV Therapy",
  3: "Supplements",
  4: "Pharmaceuticals",
  5: "Pharmaceuticals IV",
  6: "Lab work",
  7: "Medical procedures",
  8: "Lab panel",
};

export const enSvcAttributeType: Record<number, string> = {
  0: "None",
  1: "Range (label/min/max/unit)",
  2: "Text (label/text/unit)",
  3: "Number (label/number/unit)",
  4: "Time (label/time/time unit)",
  5: "Time range (label/time min/time max/time unit)",
  6: "List (label/text list)",
  7: "Period range (label/time min/time max/time unit)",
};

export const enTimeUnit: Record<number, string> = {
  1: "seconds",
  2: "minutes",
  3: "hours",
  4: "days",
  5: "weeks",
  6: "months",
  7: "years",
};

/** Formats a time unit with parentheses for singular/plural display (e.g., "seconds" -> "second(s)") */
export const formatTimeUnitWithParen = (unit: string): string =>
  unit.replace(/s$/, "(s)");

export const enSvcUDurationCategory = {
  2: "Calendar range",
  3: "Unlimited scheduling",
};

export const enSvcUBillingType: Record<number, string> = {
  1: "Per session",
  2: "Per package",
  3: "From price (minimum price)",
};
